import React from "react";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const DIAS = [
  { key: "seg", label: "Segunda", curto: "Seg" },
  { key: "ter", label: "Terça", curto: "Ter" },
  { key: "qua", label: "Quarta", curto: "Qua" },
  { key: "qui", label: "Quinta", curto: "Qui" },
  { key: "sex", label: "Sexta", curto: "Sex" },
  { key: "sab", label: "Sábado", curto: "Sáb" },
  { key: "dom", label: "Domingo", curto: "Dom" },
];
const KEYS = DIAS.map((d) => d.key);
export const DIAS_SEG_SEX = KEYS.slice(0, 5);

export const descreverProgramacao = (tipo) => {
  const per = tipo?.periodicidade || "diaria_1x";
  if (per.startsWith("diaria")) {
    const dias = tipo.dias_semana?.length ? tipo.dias_semana : DIAS_SEG_SEX;
    if (dias.length === 7) return "Todos os dias";
    if (dias.length === 6 && !dias.includes("dom")) return "Seg a Sáb";
    if (dias.length === 5 && !dias.includes("sab") && !dias.includes("dom")) return "Seg a Sex";
    return DIAS.filter((d) => dias.includes(d.key)).map((d) => d.curto).join(", ");
  }
  if (per === "semanal" || per === "quinzenal") {
    return DIAS.find((d) => d.key === (tipo.dia_semana || "seg"))?.label || "";
  }
  if (per === "mensal") return `dia ${tipo.dia_mes || 1}`;
  return "";
};

export const ProgramacaoRotina = ({ form, setForm }) => {
  const per = form.periodicidade || "diaria_1x";
  const dias = form.dias_semana?.length ? form.dias_semana : DIAS_SEG_SEX;

  if (per.startsWith("diaria")) {
    const setDias = (lista) => setForm({ ...form, dias_semana: lista });
    const toggle = (key) => setDias(dias.includes(key) ? dias.filter((d) => d !== key) : KEYS.filter((k) => k === key || dias.includes(k)));
    const preset = (n) => setDias(KEYS.slice(0, n));
    const ativo = (n) => dias.length === n && KEYS.slice(0, n).every((k) => dias.includes(k));
    return (
      <div className="space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="rotina-dias-semana">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <Label className="text-sm">Dias em que a rotina é feita</Label>
          <div className="flex gap-1">
            <Button type="button" size="sm" variant={ativo(5) ? "default" : "outline"} className="h-7 text-xs" onClick={() => preset(5)} data-testid="rotina-preset-seg-sex">Seg–Sex</Button>
            <Button type="button" size="sm" variant={ativo(6) ? "default" : "outline"} className="h-7 text-xs" onClick={() => preset(6)} data-testid="rotina-preset-seg-sab">Seg–Sáb</Button>
            <Button type="button" size="sm" variant={ativo(7) ? "default" : "outline"} className="h-7 text-xs" onClick={() => preset(7)} data-testid="rotina-preset-todos">Todos os dias</Button>
          </div>
        </div>
        <div className="grid grid-cols-7 gap-1">
          {DIAS.map((d) => (
            <label key={d.key} className="flex flex-col items-center gap-1 rounded-md border border-slate-200 bg-white py-2 text-xs cursor-pointer">
              <span className="font-medium text-slate-600">{d.curto}</span>
              <Checkbox checked={dias.includes(d.key)} onCheckedChange={() => toggle(d.key)} data-testid={`rotina-dia-${d.key}`} />
            </label>
          ))}
        </div>
      </div>
    );
  }

  if (per === "semanal" || per === "quinzenal") {
    return (
      <div className="space-y-2">
        <Label>Dia da semana *</Label>
        <Select value={form.dia_semana || "seg"} onValueChange={(v) => setForm({ ...form, dia_semana: v })}>
          <SelectTrigger data-testid="rotina-dia-semana"><SelectValue /></SelectTrigger>
          <SelectContent>
            {DIAS.map((d) => <SelectItem key={d.key} value={d.key}>{d.label}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="text-xs text-slate-500">A rotina só aparece como pendente a partir desse dia, até ser registrada na semana.</p>
      </div>
    );
  }

  if (per === "mensal") {
    return (
      <div className="space-y-2">
        <Label>Dia do mês *</Label>
        <Select value={String(form.dia_mes || 1)} onValueChange={(v) => setForm({ ...form, dia_mes: parseInt(v) })}>
          <SelectTrigger data-testid="rotina-dia-mes"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Array.from({ length: 28 }, (_, i) => i + 1).map((d) => <SelectItem key={d} value={String(d)}>Dia {d}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="text-xs text-slate-500">A rotina só aparece como pendente a partir desse dia, até ser registrada no mês.</p>
      </div>
    );
  }
  return null;
};
